import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmations-popup.component.html',
  styleUrls: ['./confirmations-popup.component.scss']
})
export class ConfirmationsPopupComponent implements OnInit {

  @Input() title:string="";
  @Input() prefixMessage:string="";
  @Input() message:string="";
  @Input() suffixMessage:string="";
  @Input() label:string="";
  @Input() isSuccess: boolean = false; // for handling post-submit UI


  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  confirmAttendExam() {
    this.modal.close(true); // This will send 'true' back to the calling component
  }
  
  goBack() {
    this.modal.dismiss('cancel click'); // This will simply close the modal
  }
}

